import React, { useEffect, useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap';
import { deleteRestoreAttendance } from '../../api/attendance';

const DeleteAttendanceModal = ({
  modalOpenState,
  closeModalHandler,
  attendanceId,
  type,
  fetchNewData,
  attendanceInfo,
  setLeaveBalance
}) => {
  const [successAlert, setSuccessAlert] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);
  const [requestError, setRequestError] = useState({
    show_alert: false,
    message: ''
  });

  function showErrorAlert(message) {
    setRequestError({ message: message, show_alert: true });
  }

  function resetErrorAlert() {
    setRequestError({ message: '', show_alert: false });
  }
  const deleteAttendance = async () => {
    resetErrorAlert();
    setRequestLoading(true);

    const { response, error } = await deleteRestoreAttendance(attendanceId);

    if (response) {
  setRequestLoading(false);

  const leaveDays =
    Math.floor(
      (new Date(attendanceInfo.end_date) -
        new Date(attendanceInfo.start_date)) /
        (1000 * 60 * 60 * 24)
    ) + 1;

  setLeaveBalance((prev) => {
    const updated = { ...prev };

    if (type === 'delete') {
      if (attendanceInfo.type === 'Paid Leave') {
        updated.paid.requested -= leaveDays;
        updated.paid.available += leaveDays;
      }

      if (attendanceInfo.type === 'Saturday Leave') {
        updated.saturday.requested -= 1;
        updated.saturday.available += 1;
      }

      if (attendanceInfo.type === 'Unpaid Leave') {
        updated.unpaid.requested -= leaveDays;
      }
    }

    if (type === 'restore') {
      if (attendanceInfo.type === 'Paid Leave') {
        updated.paid.requested += leaveDays;
        updated.paid.available -= leaveDays;
      }

      if (attendanceInfo.type === 'Saturday Leave') {
        updated.saturday.requested += 1;
        updated.saturday.available -= 1;
      }

      if (attendanceInfo.type === 'Unpaid Leave') {
        updated.unpaid.requested += leaveDays;
      }
    }

    return { ...updated };
  });

  setSuccessAlert(
    `Attendance ${type === 'restore' ? 'restored' : 'deleted'} successfully`
  );

  fetchNewData();
  closeModalHandler();
}
    if (error) {
      setRequestLoading(false);
      showErrorAlert(error);
      return;
    }
  };

  useEffect(() => {
    resetErrorAlert();
  }, [modalOpenState]);
  return (
    <React.Fragment>
      {successAlert && (
        <SweetAlert
          success
          title={type === 'restore' ? 'Restored' : 'Deleted'}
          onConfirm={() => setSuccessAlert(false)}
        >
          {successAlert}
        </SweetAlert>
      )}

      <Modal isOpen={modalOpenState} backdrop="static" size="md">
        <ModalHeader toggle={closeModalHandler}></ModalHeader>
        <ModalBody>
          {requestError && (
            <Alert
              color="danger"
              role="alert"
              isOpen={requestError.show_alert}
              toggle={resetErrorAlert}
            >
              <i className="mdi mdi-block-helper mr-2"></i>
              {requestError.message}
            </Alert>
          )}
          <h4>{`Are you sure you want to ${type} this request?`}</h4>
        </ModalBody>
        <ModalFooter>
          <Button
            disabled={requestLoading}
            type="button"
            color="light"
            onClick={closeModalHandler}
          >
            Close
          </Button>
          <Button
            type="submit"
            color="danger"
            onClick={() => deleteAttendance()}
          >
            {requestLoading
              ? type === 'restore'
                ? 'Restoring ...'
                : 'Deleting...'
              : type === 'restore'
                ? 'Restore'
                : 'Delete'}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default DeleteAttendanceModal;
